import { offerings, steps, email, emailText, headshot, tagline, belief, about, contact, socials, year } from "./content";
import Switcher from "./Switcher";
import "./ledger.css";

export default function Ledger() {
  return (
    <div className="d1" id="top">
      <a className="d1-skip" href="#main">Skip to content</a>

      <header className="d1-header d1-wrap">
        <a className="d1-brand" href="#top" aria-label="Bit Haiku home">Bit Haiku</a>
        <p className="d1-meta">
          <span>Statement of work</span>
          <span>Custom software &amp; AI automation</span>
        </p>
        <nav aria-label="Main navigation">
          <a href="#services">Services</a>
          <a href="#about">About</a>
          <a href="#contact">Contact</a>
        </nav>
      </header>

      <main id="main">
        <section className="d1-hero d1-wrap" aria-labelledby="d1-hero-title">
          <div className="d1-hero-copy">
            <p className="d1-kicker">Entry 001 · Software · AI automation · Security</p>
            <h1 id="d1-hero-title">
              More business,<br />
              <em>less busywork.</em>
            </h1>
            <p className="d1-lead">{tagline}</p>
            <a className="d1-cta" href="#contact">Open a conversation</a>
          </div>

          <table className="d1-table">
            <caption>How a project goes</caption>
            <thead>
              <tr>
                <th scope="col">№</th>
                <th scope="col">Step</th>
                <th scope="col">What happens</th>
              </tr>
            </thead>
            <tbody>
              {steps.map((step) => (
                <tr key={step.id}>
                  <td className="d1-tab">{step.id}</td>
                  <th scope="row">{step.title}</th>
                  <td>{step.text}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <section className="d1-services d1-wrap" id="services" aria-labelledby="d1-services-title">
          <div className="d1-section-head">
            <p className="d1-kicker">Services</p>
            <h2 id="d1-services-title">Remove the pain from your processes.</h2>
          </div>
          {offerings.map((offering) => (
            <article key={offering.id} className="d1-row">
              <span className="d1-num" aria-hidden="true">{offering.id}</span>
              <div className="d1-row-body">
                <h3>{offering.title}</h3>
                <p>{offering.text}</p>
              </div>
              <ul className="d1-spec" aria-label={`${offering.title} includes`}>
                {offering.items.map((item) => (
                  <li key={item}>
                    <span>{item}</span>
                    <span className="d1-incl">incl.</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </section>

        <section className="d1-note d1-wrap" aria-labelledby="d1-belief-title">
          <p className="d1-kicker">Note to file</p>
          <h2 id="d1-belief-title">{belief.title}</h2>
          <div className="d1-note-body">
            {belief.paragraphs.map((text) => <p key={text}>{text}</p>)}
          </div>
        </section>

        <section className="d1-about d1-wrap" id="about" aria-labelledby="d1-about-title">
          <figure>
            <img src={headshot} alt={about.alt} width="440" height="440" loading="lazy" />
            <figcaption>{about.name} · {about.role}</figcaption>
          </figure>
          <div>
            <p className="d1-kicker">Who you’ll work with</p>
            <h2 id="d1-about-title">{about.title}</h2>
            {about.paragraphs.map((text) => <p key={text}>{text}</p>)}
            <a className="d1-inline" href="#contact">{about.cta} →</a>
          </div>
        </section>

        <section className="d1-contact d1-wrap" id="contact" aria-labelledby="d1-contact-title">
          <p className="d1-kicker">Get in touch</p>
          <h2 id="d1-contact-title">What would simplicity feel like?</h2>
          <p className="d1-contact-copy">{contact.lines.join(" ")}</p>
          <div className="d1-total">
            <span>Total due</span>
            <span>One email.</span>
          </div>
          <a className="d1-email" href={email}>{emailText}</a>
        </section>
      </main>

      <footer className="d1-footer d1-wrap">
        <span>© {year} Bit Haiku LLC</span>
        <div>
          {socials.map((s) => <a key={s.label} href={s.href} target="_blank" rel="noreferrer">{s.label}</a>)}
        </div>
      </footer>
      <Switcher current={1} />
    </div>
  );
}
